import React, { Component } from "react";
import "./Guide.css";
// import EditableCell from '../components/EditableCell'
import {
    Row, Col, Divider, Button, 
} from 'antd';

import { Link } from "react-router-dom";

import guide16 from "../img/guide/guide_Page_16.png";
import guide17 from "../img/guide/guide_Page_17.png";
import guide18 from "../img/guide/guide_Page_18.png";
import guide19 from "../img/guide/guide_Page_19.png";
import guide20 from "../img/guide/guide_Page_20.png";
import guide21 from "../img/guide/guide_Page_21.png";
import guide22 from "../img/guide/guide_Page_22.png";
import guide23 from "../img/guide/guide_Page_23.png";
import guide24 from "../img/guide/guide_Page_24.png";
import guide25 from "../img/guide/guide_Page_25.png";
import guide26 from "../img/guide/guide_Page_26.png";
import guide27 from "../img/guide/guide_Page_27.png";
import guide28 from "../img/guide/guide_Page_28.png";
import guide29 from "../img/guide/guide_Page_29.png";
import guide30 from "../img/guide/guide_Page_30.png";
import guide32 from "../img/guide/guide_Page_32.png";

export default class GuideMAMCA extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }

    next() {
        this.carousel.next();
    }
    previous() {
        this.carousel.prev();
    }

    componentDidMount() {
        try {
        } catch (e) {
            alert(e);
        }
    }

    render() {

        return <div className="Guide">
            <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                <h3 >Multi-Actor Multi-Criteria Analysis</h3>
            </Row>
            <Divider />
            <Row type="flex" justify="space-around"  align="middle">
                {/* <Col span={2}><Button type="primary" size="large" onClick={this.previous}><Icon type="caret-left" /></Button></Col> */}
                <Col span={20}>
                    {/* <Carousel  ref={node => (this.carousel = node)}className="ant-carousel"> */}
                    <div>
                            <img src={guide16} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide17} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide18} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide19} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide20} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide21} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide22} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide23} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide24} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide25} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide26} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide27} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide28} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide29} style={{ width: "100%" }} alt="guide" />
                        </div>
                        <div>
                            <img src={guide30} style={{ width: "100%" }} alt="guide" />
                        </div>
                        {/* <div>
                            <img src={guide32} style={{ width: "100%" }} alt="guide" />
                        </div> */}
                    {/* </Carousel> */}
                </Col>
                {/* <Col span={2}><Button type="primary" size="large" onClick={this.next}><Icon type="caret-right" /></Button></Col> */}
            </Row>
            <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
            <Button size="large" type="primary" >
                        <Link to={`/guide`}>Back</Link></Button>
                <Button type="primary" size="large">
                    <a href="mailto:info@mamca.eu">Contact us for more info!</a>
                </Button>
            </Row>
            {/* <Divider /> */}
        </div>;
    }
}
